export default __webpack_public_path__ + "static/media/closeWhite.39a9877c.svg";